import { clsx } from 'clsx'
import type { InputHTMLAttributes } from 'react'
import { useEffect, useState } from 'react'
import minusButton from '../../../assets/images/buttons/minus-button.svg'
import plusButton from '../../../assets/images/buttons/plus-red-button.svg'
import { getStepForInputByMinMax } from '../../../utils'
import { Icon, Input } from '../../atoms'
import { InputWrapper } from '../InputWrapper'
import {
  buttonStyle,
  disabledInput,
  inputContainer,
  inputWrapped,
  inputWrapper,
} from './index.css'

export const InputNumberWithButtons = (
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
    value: number
    min: number
    max: number
    onChange: (value: number) => void
  },
) => {
  const [value, setValue] = useState(props.value)
  const [step, setStep] = useState(
    props.step
      ? Number(props.step)
      : getStepForInputByMinMax(props.min, props.max),
  )

  const onChange = (value: number | undefined) => {
    if (typeof value === 'undefined') {
      return
    }
    setValue(() => value)
    props.onChange(value)
  }

  const onClickButton = (side: '+' | '-') => {
    if (props.disabled) {
      return
    }
    const newValue = side === '+' ? Number(value) + step : Number(value) - step
    if (newValue > props.max || newValue < props.min) {
      return
    }
    const formatedNewValue = Number(
      (Math.floor(newValue * 100) / 100).toFixed(2),
    )
    setValue(() => formatedNewValue)
    props.onChange(formatedNewValue)
  }

  useEffect(() => {
    setValue((currentValue) => props.value ?? currentValue)
  }, [props.value])

  useEffect(() => {
    setStep(() =>
      props.step
        ? Number(props.step)
        : getStepForInputByMinMax(props.min, props.max),
    )
  }, [props.step, props.min, props.max])

  return (
    <div className={clsx(inputContainer, props.disabled && disabledInput)}>
      <Icon
        src={minusButton}
        className={buttonStyle}
        onClick={() => onClickButton('-')}
      />
      {props.children ? (
        <InputWrapper
          {...props}
          type='number'
          hideNumberArrows={true}
          className={clsx(props.className, inputWrapper)}
          classNameWrapped={inputWrapped}
          onChange={onChange}
        >
          {props.children}
        </InputWrapper>
      ) : (
        <Input
          {...props}
          type='number'
          hideNumberArrows={true}
          onChange={onChange}
        />
      )}
      <Icon
        src={plusButton}
        className={buttonStyle}
        onClick={() => onClickButton('+')}
      />
    </div>
  )
}
